var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.7342 0.599816C5.92947 0.795078 5.92947 1.11166 5.7342 1.30692L2.54109 4.50004H12.6673C12.9435 4.50004 13.1673 4.72389 13.1673 5.00004C13.1673 5.27618 12.9435 5.50004 12.6673 5.50004H2.54109L5.7342 8.69315C5.92947 8.88841 5.92947 9.20499 5.7342 9.40026C5.53894 9.59552 5.22236 9.59552 5.0271 9.40026L0.980431 5.35359C0.886663 5.25982 0.833984 5.13264 0.833984 5.00004C0.833984 4.86743 0.886663 4.74025 0.980431 4.64648L5.0271 0.599816C5.22236 0.404554 5.53894 0.404554 5.7342 0.599816Z",
    fill: "#022964"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackBtn);
export default __webpack_public_path__ + "static/media/back-btn.b92d3d2a8cdc3f9d070f1dc3110d6368.svg";
export { ForwardRef as ReactComponent };